
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import MainLayout from '@/components/layouts/MainLayout';
import { useAuthor } from '@/hooks/useAuthors';
import EditReportDialog from '@/components/admin/EditReportDialog';
import EditReportLoadingState from '@/components/admin/EditReportLoadingState';
import EditReportNotFound from '@/components/admin/EditReportNotFound';
import EditReportHeader from '@/components/admin/EditReportHeader';
import { useReportGroup } from '@/hooks/useReportGroup';

const RoyaltyReportEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(true);
  
  const { reportGroup, report, isLoading } = useReportGroup(id || '');
  const { data: author } = useAuthor(report?.authorId || '');

  const handleEditSuccess = () => {
    setIsEditDialogOpen(false);
    navigate(`/admin/royalties/${id}`);
  };

  const handleDialogClose = (open: boolean) => {
    setIsEditDialogOpen(open);
    if (!open) {
      navigate(`/admin/royalties/${id}`);
    }
  };
  
  if (isLoading) {
    return <EditReportLoadingState />;
  }
  
  if (!report) {
    return <EditReportNotFound />;
  }
  
  return (
    <MainLayout allowedRoles={['admin']}>
      <EditReportHeader
        reportId={id!}
        authorName={author?.name}
        quarter={report.quarter}
        year={report.year}
      />
      
      <EditReportDialog
        open={isEditDialogOpen}
        onOpenChange={handleDialogClose}
        reportGroup={reportGroup}
      />
    </MainLayout>
  );
};

export default RoyaltyReportEdit;
